import PARTIES from "@/data/parties.yml";
import SAVE_THE_DATE from "@/data/save-the-date.yml";
import PartyAgenda from "@/components/party-agenda";
import DateToFormat from "@/components/date-to-format";
import dynamicLocalization from "@/mixins/dynamic-localization";
import objToDate from "@/mixins/obj-to-date";

const NEXT_PARTY_DATE = JSON.parse(process.env.VUE_APP_NEXT_PARTY_DATE);
const TICKET_SALE_START = JSON.parse(process.env.VUE_APP_TICKET_SALE_START);

export default {
  components: { PartyAgenda, DateToFormat },
  mixins: [dynamicLocalization, objToDate],
  data() {
    const ticketSaleStart = this.objToDate(TICKET_SALE_START);
    const nextPartyDate = this.objToDate(NEXT_PARTY_DATE);

    const now = new Date();
    const ticketSaleStartAvailable = ticketSaleStart && now < ticketSaleStart;

    return {
      nextPartyDate,
      ticketSaleStart,
      ticketSaleStartAvailable,
      PARTIES,
      SAVE_THE_DATE,
    };
  },
  computed: {
    eventsInCalendarTile() {
      let calendarTiles = [];

      for (let i = 0; i < 42; i++) {
        calendarTiles.push([]);
      }

      this.SAVE_THE_DATE.calendar.events.map((event) => {
        calendarTiles[this.firstDayOffset + event.day].push(event);
      });

      return calendarTiles;
    },
    firstOfMonth() {
      return new Date(
        this.SAVE_THE_DATE.calendar.year,
        this.SAVE_THE_DATE.calendar.month - 1,
        1
      );
    },
    firstDayOffset() {
      return this.firstOfMonth.getDay() - 1;
    },
    lastOfMonth() {
      return new Date(
        this.SAVE_THE_DATE.calendar.year,
        this.SAVE_THE_DATE.calendar.month,
        0
      );
    },
  },
  methods: {
    dayHasEvent(day) {
      return false;
      // return this.eventDates.some((date, idx) => {
      //   return this.displayDay(idx, week, day) === date.getDate();
      // });
    },
    dayClasses(idx) {
      return this.eventsInCalendarTile[idx].map((event) => {
        return event.accent;
      });
    },
    dayInMonth(idx) {
      return (
        idx > this.firstDayOffset &&
        idx <= this.lastOfMonth.getDate() + this.firstDayOffset
      );
    },
    displayDay(idx) {
      if (idx < 7 && idx < this.firstOfMonth.getDay()) {
        return null;
      }

      let dayOffset = idx - this.firstDayOffset;

      if (dayOffset > this.lastOfMonth.getDate()) {
        return null;
      }

      return dayOffset;
    },
    weekDayLocalized(day) {
      return ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"][day - 1];
    },
  },
};
